import * as notification from './notification';
import NotificationProvider from './NotificationProvider';

export default notification;
export { NotificationProvider };
